import { CerFormAdapter } from '@form/cer-form-adapter';
import { CerFormViewSet } from '@form/cer-form-view-set';
import { CerFormView } from '@form/cer-form-view';
import { FieldEditChangedArgs } from '@cer/cer-data/cer-data-types';
import { UiActionTypeEnum, UiCommandEvent, UiCommandSourceEnum } from '@cer/cer-ui/cer-ui-types';
import { ParentDataArgs } from '@cer/cer-form/cer-form.service';
import { WarehouseOnhandCostJournalLineView } from '@app/api';

export class WarehouseOnhandCostPriceGroupAgeForm extends CerFormAdapter {

  override viewSetInit(viewSet: CerFormViewSet) {
    viewSet.viewAdd(this.viewGet());
  }

  private viewGet() {
    return new CerFormView({
      viewMetadata: {
        name: 'b-kostpriser', dataApiName: 'WarehouseOnhandCostPriceGroupAge', text: 'B-kostpriser',
        primaryKey: 'id', baseFields: ['id', 'history'], titleFields: ['group', 'transDate'],
        onParentValueGet: (e) => { return this.onParentValueGet(e) }
      },
      fieldMetadata: [
        { name: 'group', text: 'Gruppe', foreignKeyType: 'productGroup', orderBy: 'Ascending', orderByPriority: 2 },
        { name: 'product', text: 'ISBN', foreignKeyType: 'productProject', orderBy: 'Ascending', orderByPriority: 1, onEditChanged: (e => this.onProductChanged(e)) },
        { name: 'product', text: 'Projekt', width: '60px', foreignKeyType: 'productProject', foreignKeyField: 'num', foreignKeyValue: 'projectNum', allowFiltering: false, allowSorting: false, onEditChanged: (e => this.onProjectNumChanged(e)) },
        { name: 'product', text: 'Titel', foreignKeyType: 'productProject', foreignKeyField: 'num', foreignKeyValue: 'name', allowFiltering: false, allowSorting: false, allowEdit: false },
        { name: 'ageMonths', text: 'Udgivet måneder', format: 'Integer', orderBy: 'Ascending', orderByPriority: 3 },
        { name: 'costPrice', text: 'Kostpris nedskrevet', format: 'Amount', required: true },
      ],
      onCommandEvent: (e) => { this.onCommandEvent(e) }
    });
  }

  private parentRow: WarehouseOnhandCostJournalLineView;
  private onParentValueGet(e: ParentDataArgs): string {
    if (e.row != null && e.typeName == 'WarehouseOnhandCostJournalLineView') {
      this.parentRow = e.row;
      return this.parentRow.productNum;
    }
    return null;
  }

  private onCommandEvent(e: UiCommandEvent) {
    if (e.source == UiCommandSourceEnum.ActionComplete && e.actionType == UiActionTypeEnum.Add && this.parentRow != null) {
      this.initFromParentRow(e, this.parentRow);
    }
  }

  private initFromParentRow(event: UiCommandEvent, parentRow: WarehouseOnhandCostJournalLineView) {
    const e = event.appComponent.editService;
    const productNum = parentRow?.productNum;
    if (productNum?.length > 0) {
      e.fieldValueSet('product', productNum, 0);
      e.fieldValueSet('product', productNum, 1);
      e.fieldValueSet('product', productNum, 2);
    }
  }

  private onProductChanged(e: FieldEditChangedArgs): void {
    e.editService.fieldValueSet('product', e.value, 1);
    e.editService.fieldValueSet('product', e.value, 2);
  }

  private onProjectNumChanged(e: FieldEditChangedArgs): void {
    e.editService.fieldValueSet('product', e.value, 0);
    e.editService.fieldValueSet('product', e.value, 2);
  }
}
